var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reportee-dep-badge",class:_vm.clzObj},[_vm._v(" "+_vm._s(_vm.dispStr)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }